import styles from './styles.module.css';
import PropTypes from 'prop-types';

function KitoButton({ children, type = 'button', hierarchy = 'primary', ...rest }) {
  return (
    <button className={styles.kitoButton} type={type} hierarchy={hierarchy} {...rest}>
      {children}
    </button>
  );
}

KitoButton.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  hierarchy: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'icon']),
  rest: PropTypes.objectOf({
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    variant: PropTypes.oneOf(['default', 'warning', 'danger', 'info', 'success']),
  }),
};

KitoButton.defaultProps = {
  hierarchy: 'primary',
  rest: {
    onClick: () => { },
    disabled: false,
    variant: 'default',
  },
};

export default KitoButton;
